import { Component } from '@angular/core';
import {
    UilabMatIconButton,
    UilabMatIconModule,
} from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { ICONS } from 'src/app/shared/constants/icons';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface IconButtonExample {
    readonly variant: 'default';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
}

@Component({
    selector: 'avd-icon-button-examples',
    templateUrl: './icon-button-examples.component.html',
    styleUrls: ['./icon-button-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatIconButton,
        UilabMatIconModule,
    ],
})
export class IconButtonExamplesComponent {
    readonly ICONS = ICONS;
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/docs/components-buttons-icon-button--docs`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/buttons/icon-button`;

    readonly examples: readonly IconButtonExample[] = [
        {
            variant: 'default',
            label: 'Default Icon Button',
            description:
                'Use icon buttons for compact actions where the icon clearly communicates intent.',
            htmlSnippet: `<button uilabMatIconButton aria-label="home">
  <uilab-mat-icon svgIcon="${ICONS.homeFilled}"></uilab-mat-icon>
</button>`,
        },
    ];
}
